__turbopack_context__.v({
  "copy": "soT8Ca_copy",
  "externalIcon": "soT8Ca_externalIcon",
  "externalLink": "soT8Ca_externalLink",
  "icon": "soT8Ca_icon",
  "isOpen": "soT8Ca_isOpen",
  "navItem": "soT8Ca_navItem",
  "slideAndFadeIn": "soT8Ca_slideAndFadeIn",
  "subNav": "soT8Ca_subNav",
  "subNavList": "soT8Ca_subNavList",
  "subNavToggle": "soT8Ca_subNavToggle",
});
